import Vue from 'vue';
import Vuex, { ActionTree, GetterTree, MutationTree, StoreOptions } from 'vuex';
import firebase from 'firebase/app';
import 'firebase/auth';

import VueCookies from 'vue-cookies';

import api from '@/api';
import { RootState } from 'types';
import { getGeneralisedEntityByMode } from '@/utils/helpers';

Vue.use(Vuex);
Vue.use(VueCookies);

export const state: RootState = {
    user: {
        email: ''
    },
    intent: '',
    networks: [],

    structures: {
        'CONV_ORGANISATION': [],
        'CONV_BRANCH': [],
        'EA_ORGANISATION': [],
        'EA_BRANCH': [],
        'MORTGAGE_USER': []
    },

    shortInfo: {},

    mode: '',

    modalActive: false,
    modalMode: '',
    modalData: {},
};

export const getters: GetterTree<RootState, any> = {
    getUser: state => state.user
};

export const mutations: MutationTree<RootState> = {
    setUser(state, value) {
        state.user = value;
    },

    setIntent(state, value) {
        state.intent = value;
    },

    setMode(state, value) {
        state.mode = value;
    },

    setNetworks(state, value) {
        state.networks = value;
    },

    setShortInfo(state, value) {
        state.shortInfo = value;
    },

    setStructures(state, { data, mode }) {
        state.structures[mode] = data;
    },

    toggleModal(state) {
        state.modalActive = !state.modalActive;
    },

    showModal(state) {
        state.modalActive = true;
    },

    closeModal(state) {
        state.modalActive = false;
    },

    setModalMode(state, value) {
        state.modalMode = value;
    },

    setModalData(state, value) {
        state.modalData = value;
    }
};

export const actions: ActionTree<RootState, any> = {
    getUserShortInfo({ commit }) {
        commit('toggleLoading');

        return api.get('/api/users/shortInfo').then(({ data }) => {
            console.log(data);
            commit('setShortInfo', data);
            commit('toggleLoading');
        }).catch(e => new Error(e));
    },

    signIn() {
        const provider = new firebase.auth.OAuthProvider('microsoft.com');
        provider.setCustomParameters({
            tenant: '413ce4cc-5ac1-4b55-88fb-14bbd4aa78b4'
        });

        return firebase.auth().signInWithPopup(provider).catch(function(error) {
            // Handle error.
            console.log('Err: ', error);
            alert('Something went wrong. Please reload page and try again');
        });
    },
    signOut() {
        firebase.auth().signOut();
    },

    getNetworkByUuid(context, uuid) {
        return api.get(`/api/network/${uuid}`);
    },

    loadBranches(context, { mode, uuid }) {
        const keyword = mode === 'EA_BRANCH' ? 'agency': 'conveyancing',
            endpoint = `/api/network/${keyword}/${uuid}/branches`;

        return api.get(endpoint);
    },

    addConnection(context, body) {
        return api.post('/api/network', JSON.stringify(body));
    },

    removeConnection(context, partnerUuids) {
        const [firstPartner, secondPartner] = partnerUuids;
        return api.delete(`/api/network/${firstPartner}/${secondPartner}`);
    },

    loadStructures({ commit }, mode) {
        return api.get(`/api/network/${getGeneralisedEntityByMode(mode)}`, {withCredentials: true}).
            then(({ data }) => commit('setStructures', { data, mode }));
    },

    discardInvitation(context, body) {
        return api.put('/api/network/invitation/batchClean', body);
    }

};

const store: StoreOptions<RootState> = {
    state,
    getters,
    mutations,
    actions
};

export default new Vuex.Store<RootState>(store);
